/** Splits a second count into whole hours, minutes and seconds. */
function breakdown(timeInSeconds: number): { hours: number; minutes: number; seconds: number } {
    let seconds = Math.floor(timeInSeconds);

    const hours = Math.floor(seconds / (60 * 60))
    seconds %= (60 * 60)

    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    return { hours, minutes, seconds }
}

/** Clock format for players and scrub bars: "0:45", "45:00", "1:30:00". */
export function DurationFormatter(timeInSeconds: number): string {

    if (isNaN(timeInSeconds) || !isFinite(timeInSeconds)) {
        return "0:00"
    }

    const { hours, minutes, seconds } = breakdown(timeInSeconds)

    const secondsStr = seconds < 10 ? `0${seconds}` : seconds.toString()

    if (hours > 0) {
        const minutesStr = minutes < 10 ? `0${minutes}` : minutes.toString()
        return `${hours}:${minutesStr}:${secondsStr}`
    } else {
        return `${minutes}:${secondsStr}`
    }

  }

export function DurationRuntime(timeInSeconds: number): string | undefined {

    if (isNaN(timeInSeconds) || !isFinite(timeInSeconds) || timeInSeconds < 0) {
        return undefined
    }

    const { hours, minutes } = breakdown(timeInSeconds)

    if (hours > 0) {
        return `${hours}h ${minutes}m`
    }

    return `${minutes}m`
}
